module.exports = __webpack_public_path__ + "img/phase-4.dbaaf9e0.svg";